import React, { createContext, useState, useEffect } from "react";

export const BackgroundContext = createContext();

const BackgroundContextProvider = props => {
  const [img, setImg] = useState({});
  const [styles, setStyles] = useState();
  const [path, setPath] = useState("");

  useEffect(() => {}, [img]);

  const setImage = (path, link) => {
    const bgImgDefault =
      "linear-gradient(rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)),";

    let cssRules = {
      backgroundImage: `${bgImgDefault} url(${link})`,
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat"
    };

    link ? setImg(cssRules) : setImg({});
  };

  return (
    <BackgroundContext.Provider value={{ setImage: setImage }}>
      <div style={img}>{props.children}</div>
    </BackgroundContext.Provider>
  );
};

export default BackgroundContextProvider;
